import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 安否確認回答 API 操作クラス
 */
export default class SafetyConfirmReplyMessages {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET SafetyConfirmReplyMessages
   */
  public async gets(userStore: LoginUser, messagesSortKey: string): Promise<Array<SafetyConfirmReplyMessagesGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      messagesSortKey: messagesSortKey
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SafetyConfirmReplyMessages, formatParams);

    const response = await this.commonService.executeGet<Array<SafetyConfirmReplyMessagesGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      null,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }
}

export interface SafetyConfirmReplyMessagesGetModel {
  /** 施設ID */
  facilityId: number;
  /** ソートキー */
  replyOtherUserSafetyConfirms: string;
  /** 安否確認(施設関係者)のソートキー */
  parentSafetyConfirmsSortKey: string;
  /** 返信先メッセージのソートキー */
  parentOtherUserMessagesSortKey: string;
  /** グループ ID */
  groupId: number;
  /** メンバー ID */
  memberId: number;
  /** 返信元メッセージの時間 */
  sourceMessageDatetime: number;
  /** 安否確認メッセージ（施設関係者）の質問内容の回答 */
  answers: Array<OtherUserConfirmationAnswersContents>;
  /** グループ名 */
  groupName: string;
  /** グループ種類 ID */
  groupTypeId: number;
  /** グループメンバー名 */
  groupMemberName: string;
  /** グループメンバー電話番号 */
  groupMemberTel: string;
  /** グループメンバー所属 */
  groupMemberOrganization: string;
  /** 最新の情報か */
  latest: boolean;
  /** 削除フラグ */
  deleteFlag: boolean;
  /** レコード作成日 */
  created: number;
  /** レコード更新日 */
  updated: number;
}

export interface OtherUserConfirmationAnswersContents {
  /** 質問ID。マスターのIDとひもづく */
  id: number;
  /** 回答 */
  answer: string;
}
